export * from './models';

export interface NetworkEntity<T = any> {
    entities: T[];
    total: number | undefined;
    finished: boolean;
    loading: boolean;

    [key: string]: any;
}



// WEBPACK FOOTER //
// /app/src/app/types/data.types.ts